import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { IMG } from "../data/images";
import { CheckCircle2, ArrowRight, Baby, Stethoscope, GraduationCap } from "lucide-react";

export default function ForChildren() {
  return (
    <>
      <SEO
        title="Cochlear Implant for Children — Complete Parent Guide (India)"
        description="A complete, parent-friendly guide to cochlear implants for children in India. Newborn screening, best age for CI, surgery, switch-on, AVT and school readiness."
      />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <div className="text-[#0F766E] uppercase tracking-wider text-[12px] font-bold mb-3">For parents</div>
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">
            Cochlear Implant for Children
          </h1>
          <p className="mt-5 text-slate-700 text-[1.08rem] max-w-3xl">
            Early identification + early implantation + consistent therapy = the best speech and
            language outcomes for children with severe-to-profound hearing loss.
          </p>
        </div>
      </section>

      <section className="hc-container py-14 grid lg:grid-cols-3 gap-6">
        {[
          { icon: Baby, t: "Earlier is better", d: "Implantation before 18 months gives the strongest language outcomes. Most centres implant from 9–12 months." },
          { icon: Stethoscope, t: "Right tests matter", d: "OAE, BERA/ABR, ASSR and audiology — together they confirm diagnosis before CI decision." },
          { icon: GraduationCap, t: "Therapy is essential", d: "Auditory verbal therapy + family involvement for 12–24 months is as important as the surgery itself." },
        ].map((c, i) => {
          const Ico = c.icon;
          return (
            <div key={i} className="card-hc">
              <span className="w-12 h-12 rounded-xl bg-[#F0F9FF] flex items-center justify-center text-[#0369A1] mb-4"><Ico size={22} /></span>
              <div className="font-serif text-xl font-semibold text-slate-900">{c.t}</div>
              <p className="mt-2 text-slate-600 text-[15px]">{c.d}</p>
            </div>
          );
        })}
      </section>

      <section className="bg-slate-50 hc-section">
        <div className="hc-container grid lg:grid-cols-2 gap-12 items-center">
          <img src={IMG.familyChild} alt="Family with hearing-impaired child" className="rounded-3xl shadow-md" />
          <div>
            <h2 className="font-serif text-3xl font-semibold text-slate-900 leading-tight">Signs your child may need a hearing evaluation</h2>
            <ul className="mt-5 space-y-2.5">
              {[
                "Doesn't startle to loud sounds in early months",
                "Doesn't turn to voices by 6 months",
                "No babbling by 9–10 months",
                "No words by 12–15 months",
                "Doesn't respond to name",
                "Speech delay or unclear speech",
                "Hearing aids stopped helping",
              ].map((s) => <li key={s} className="flex gap-2 text-slate-700"><CheckCircle2 size={18} className="text-[#0F766E] mt-1 shrink-0" />{s}</li>)}
            </ul>
            <div className="mt-7">
              <Link to="/cochlear-implant-eligibility" className="btn-primary">Get free guidance for your child <ArrowRight size={18} className="ml-1.5" /></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
